export default __webpack_public_path__ + "static/media/benefit_1@2x.c29b21ea.png";